import React from 'react';
import { InsightIcon } from 'components/insightCard/styled';
import { insightTypeToIcon } from 'helpers/insight';
import {
  AreaHighlightCardBox,
  AreaHighlightCardWrapper,
  AreaMainInfoWrapper,
  AreaReadMore,
} from './styled';
import ChevronRightIcon from 'assets/svg/chevron-right.svg';
import { AreaHighlightItem } from './types';
import { useLocale } from 'locale';
import InsightDropdown from 'components/insight-dropdown';
import { ISendFeedbackCallbackProps } from 'utils/entities';
import { ExpandCollection } from 'store/state/insightsContext';

interface AreaHighlightCardProps extends AreaHighlightItem {
  handleClick: (id: string) => void;
  setFeedbackPopupOpen: (prop: ISendFeedbackCallbackProps) => void;
}

export const AreaHighlightCard: React.FC<AreaHighlightCardProps> = ({
  insightType,
  areaMainInfo,
  handleClick,
  setFeedbackPopupOpen,
  id,
}) => {
  const { t } = useLocale();
  const openFeedbackPopup = () => setFeedbackPopupOpen({ isOpen: true, insightId: id });

  return (
    <AreaHighlightCardBox data-auto="area-insight" insightType={insightType}>
      <InsightDropdown
        insightId={id}
        openFeedbackPopup={openFeedbackPopup}
        expandCollection={ExpandCollection.AreaHighlights}
      />
      <AreaHighlightCardWrapper
        data-auto={`area-highlight-${insightType}`}
        insightType={insightType}
        onClick={() => handleClick(id)}
      >
        <InsightIcon cardTheme={insightType} style={{ marginBottom: 16 }}>
          {insightTypeToIcon[insightType]}
        </InsightIcon>
        <AreaMainInfoWrapper>
          {areaMainInfo}
        </AreaMainInfoWrapper>
        <AreaReadMore
          data-auto="area-read-more-link"
          className="area-read-more"
          weight="medium"
        >
          {t('expandedHighlight.readMore')}
          <ChevronRightIcon />
        </AreaReadMore>
      </AreaHighlightCardWrapper>
    </AreaHighlightCardBox>
  );
};
